export const TABBED_CAROUSEL_REFRESH_LAYOUTS = {
  TEMPLATE_F: 'templateF',
};

export const TABBED_CAROUSEL_REFRESH_DEFAULT_ACTIVE_INDEX = 0;
export const TABBED_CAROUSEL_REFRESH_MAX_TABS = 5;
